import {createBrowserRouter, Navigate} from "react-router-dom";
import {PublicRoute} from "../features/auth/components/PublicRouteView";
import {LoginPage} from "../features/auth/pages/LoginView";
import {ProtectedRoute} from "../features/auth/components/ProtectedRouteView";
import DashboardView from "../features/dashboard/pages/Dashboard";
import Lesson from "../features/study/pages/Lesson";
import Review from "../features/study/pages/Review";
import ReviewSummary from "../features/study/pages/ReviewSummary";
import {Vocabulary} from "../features/vocabulary/pages/Vocabulary";
import DeckCreationWizard from "../features/deck-management/pages/DeckCreationWizard";
import DeckImporter from "../features/deck-management/pages/DeckImporter";
import React from "react";
import { NotFoundView } from "../common/components/NotFoundView";

const router = createBrowserRouter([
    {
        path: "/login",
        element: (
            <PublicRoute>
                <LoginPage />
            </PublicRoute>
        )
    },
    {
        path: "/",
        element: <Navigate to="/dashboard" replace />
    },
    {
        path: "/dashboard",
        element: (
            <ProtectedRoute>
                <DashboardView />
            </ProtectedRoute>
        )
    },
    {
        path: "/lesson",
        element: (
            <ProtectedRoute>
                <Lesson />
            </ProtectedRoute>
        )
    },
    {
        path: "/review",
        element: (
            <ProtectedRoute>
                <Review />
            </ProtectedRoute>
        )
    },
    {
        path: "/summary",
        element: (
            <ProtectedRoute>
                <ReviewSummary />
            </ProtectedRoute>
        )
    },
    {
        path: "/vocabulary",
        element: (
            <ProtectedRoute>
                <Vocabulary />
            </ProtectedRoute>
        )
    },
    {
        path: "/add-deck",
        element: (
            <ProtectedRoute>
                <DeckCreationWizard />
            </ProtectedRoute>
        )
    },
    {
        path: "/import-deck",
        element: (
            <ProtectedRoute>
                <DeckImporter />
            </ProtectedRoute>
        )
    },
    {
        path: "*",
        element: <NotFoundView />
    }
]);

export default router;